import * as React from 'react';
import { useConstCallback } from './useConstCallback';
/**
 * Hook to force update a function component by updating a dummy state.
 */
export function useForceUpdate() {
    var _a = React.useState(0), setValue = _a[1];
    var forceUpdate = useConstCallback(function () { return setValue(function (value) { return ++value; }); });
    return forceUpdate;
}
//# sourceMappingURL=useForceUpdate.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/@uifabric/react-hooks/lib/useForceUpdate.js
// module id = 621
// module chunks = 0